import React from "react";
import { Button } from "@icg360/design-system";

import { loadAmazonChat } from "../../units/load-amazon-chat";

export const AmazonChatButton = props => {
  return (
    <div {...props} data-bdd="amazon-chat-button">
      <Button
        appearance="secondary"
        leadingIcon="Chat"
        size="xs"
        onClick={loadAmazonChat}
      >
        Live chat
      </Button>
    </div>
  );
};
